const maintenanceCandidate = {
  wcId: "",
  actCode: "",
  actKind: "",
  agencyPriority: "",
  agencyStatus: "",
  brkey: null,
  docRefKey: "",
  estimCost: "",
  estimQuantity: "",
  notes: "",
  refWItemKey: null,
  strUnitKey: null,
  targetYear: null,
  workAssignment: "",
  workRecDate: "",
  bridgeApproval: null,
  coApproval: null,
  completedDate: "",
  deferredActionDesc: null,
  drawingInd: "",
  location: null,
  maintApproval: null,
  mitigationDate: null,
  permitInd: "",
  poaDate: null,
  priorityChangeDate: null,
  sapWorkOrderNum: null,
  schedCloseDate: null,
  quantity: null,
  mpmsProjectNum: null,
  inspectionWCANDAgencyPriorityHists: [],
  inspectionWCANDAudits: [],
};
export default maintenanceCandidate;
